module.exports = __webpack_public_path__ + "static/media/location-icon-unknown-severity-2.8f15b550.png";